export type BlogAudio = { kind: "file"; src: string };

// Audio briefs are self-hosted files served from /public (e.g.
// /files/blog/<slug>.m4a). Accept a root-relative path to a known audio
// extension; reject anything else so a typo doesn't render a broken player.
export function parseBlogAudio(input: string): BlogAudio | null {
  const value = input.trim();
  if (!value) return null;

  if (/^\/[^\s]+$/.test(value) && /\.(m4a|mp3|aac|ogg|opus|wav)(\?|#|$)/i.test(value)) {
    return { kind: "file", src: value };
  }

  return null;
}
